// Full Tailwind build + theme for the standalone host. Embedding hosts
// (shopify-storefront, custom-made) deliberately skip this and instead add a
// Tailwind `@source` for the package so its classes land in their own build.
import '@susu/booking-tool-v2/dist/booking-tool-v2.css'

import { createRoot } from 'react-dom/client'
import App from './App'

const rootElement = document.getElementById('root')

if (rootElement) {
  createRoot(rootElement).render(<App />)
}
